import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { Pave } from '../../models/pave.model';
import { OffreEmploi } from '../../models/offreEmploi.model';
import { PaveService } from '../../services/pave.service';

@Component({
  selector: 'offre-emploi',
  templateUrl: './offre-emploi.component.html',
  styleUrls: ['./offre-emploi.component.scss']
})
export class OffreEmploiComponent implements OnInit {
  environment = environment;

  offre: OffreEmploi;
  paves: Pave[];

  constructor(
    private route: ActivatedRoute,
    private paveService: PaveService,
    private titleService: Title,
    private metaTagService: Meta
  ) {
    this.titleService.setTitle('Centre de Formation du Languedoc');
    this.metaTagService.updateTag({
      name: 'description',
      content: 'BTS SP3S, BTS MCO, BTS SIO, offres d\'emploi'
    });
    this.offre = JSON.parse(this.route.snapshot.data.offreEmploi);
  }

  ngOnInit() {
    this.paveService.get(this.offre.instance_concernee).subscribe(res => {
      this.paves = res;
    });
  }

}
